<template>
<ckeditor :editor="editor" v-model="internalValue" :config="editorConfig"></ckeditor>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Link from '@ckeditor/ckeditor5-link/src/link';
import Font from '@ckeditor/ckeditor5-font/src/font';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import List from '@ckeditor/ckeditor5-list/src/list';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import { Undo } from '@ckeditor/ckeditor5-undo/src/';

export default {
    name: 'GunBrokerDescriptionField',
    components: {
        'ckeditor': CKEditor.component
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            internalValue: this.value,
            editor: ClassicEditor,
			editorConfig: {
                plugins: [
					Alignment,
                    Bold,
                    Italic,
                    Font,
					Underline,
                    Link,
                    Paragraph,
					Heading,
					List,
                    Undo,
                ],
                toolbar: {
                    items: [
                        'bold',
                        'italic',
						'underline',
                        'fontSize',
                        'fontFamily',
                        'fontColor',
                        'fontBackgroundColor',
						'link',
						'heading',
                        'alignment:left',
						'alignment:center',
						'alignment:right',
						'numberedList',
						'bulletedList',
                        'undo',
                        'redo',
                    ]
                },
                heading: {
		            options: [
		                { model: 'paragraph', title: 'Paragraph' },
		                { model: 'heading1', view: 'h1', title: 'Heading 1' },
						{ model: 'heading2', view: 'h2', title: 'Heading 2' },
		                { model: 'heading3', view: 'h3', title: 'Heading 3' },
						{ model: 'heading5', view: 'h5', title: 'Button' },
						{ model: 'heading6', view: 'h6', title: 'Button Light' },
					]
				},
            }
        }
    },
    watch: {
        value(newVal) {
            this.internalValue = newVal;
        },
        internalValue(newVal) {
            this.$emit('input', newVal);
        }
    }
}
</script>

<style lang="scss" scoped>
</style>